<template>
    <div>
        <div class="row q-col-gutter-md" style="direction: rtl">
            <div class="col col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <q-img
                    src="images/iranian_banks.png"
                    :ratio="1"
                />
            </div>
            <div class="col col-xs-12 col-sm-12 col-md-8 col-lg-8">
                <div style="max-width: 400px;margin: 0 auto">
                    <q-list bordered>
                        <q-item class="q-pb-none">
                            <q-item-section>
                                <div class="text-caption"> خواهشمندیم مبلغ واریز را از طریق یکی از شماره‌های زیر به حساب
                                    <b>{{ transfer.bank }}</b> به نام
                                    <b>{{ transfer.holder }}</b> واریز نمایید.</div>
                            </q-item-section>
                        </q-item>
                        <q-item v-for="account in transfer.account_numbers" :key="account.address" class="q-pt-lg">
                            <q-item-section class="col-3">
                                <q-item-label class="text-grey-7">{{networks_map[account.network]}}:</q-item-label>
                            </q-item-section>
                            <q-item-section class="q-pt-none text-left">
                                <q-item-label>
                                    <span style="padding-left:5px">{{ account.address }}</span>
                                    <q-btn
                                        outline
                                        dense
                                        size="sm"
                                        label="کپی"
                                        color="input-color"
                                        @success="copied(networks_map[account.network] + ' کپی شد')"
                                        v-clipboard="account.address.purify()"
                                        class="q-px-xs"
                                    />
                                </q-item-label>
                            </q-item-section>
                        </q-item> <!-- Account number(s) -->
                        <q-separator/>
                        <q-item class="q-pb-none">
                            <q-item-section class="col-5">
                                <q-item-label class="text-grey-7">مبلغ واریز:</q-item-label>
                            </q-item-section>

                            <q-item-section class="text-left">
                                <q-item-label>
                                    <currency-format
                                        :value="total_amount"
                                        hide-zero-decimal
                                        hide-white-spaces
                                        class="inline-block"
                                    />
                                    ریال
                                </q-item-label>
                            </q-item-section>
                            <q-item-section side style="padding-left:5px">
                                <q-btn outline
                                       dense
                                       size="sm"
                                       :label="$t('copy')"
                                       color="primary"
                                       @success="copied($t('payment-methods.templates.amount_copied'))"
                                       v-clipboard="total_amount"
                                       class="q-px-xs"
                                />
                            </q-item-section>
                        </q-item> <!-- Amount -->
                        <q-item>
                            <q-item-label caption>{{$t('payment-methods.templates.please_pay_the_exact_amount_do_not_round_this_up_down')}}</q-item-label>
                        </q-item>
                    </q-list>
                </div>
            </div> <!-- Payment Details -->
            <div class="col col-12">
                <div class="text-bold"><q-icon name="fa fa-info-circle" size="xs" color="primary" /> آنچه که باید در هنگام واریز توجه کنید: </div>
                <div v-html="instructions" class="instructions" style="direction: ltr"></div>
            </div>
            <div class="col col-12">
                <q-card flat v-if="transfer.type !== 'asap'">
                    <div class="text-bold text-italic">شما انتقال سریع وجه (ASAP Transfer Time) را انتخاب کرده‌اید. لطفاً تصویر رسید پرداخت خود را از طریق راه‌های ارتباطی زیر برای ما ارسال نمایید.</div>
                    <ul>
                        <li><b>ایمیل</b>: <a href="mailto:support@rebit.co.nz">support@rebit.co.nz</a></li>
                        <li><b>پیامک</b>: +64 22 124 8180</li>
                        <li>
                            <q-icon name="fa fa-comment" color="purple"/>
                            انتخاب یک گزینه گفتگو از گوشه‌ی همین صفحه
                        </li>
                    </ul>
                </q-card>
            </div>
        </div>
        <q-dialog v-model="openDialog">
            <q-card>
                <q-card-section>
                    <div class="text-h6">بسیار عالی!</div>
                </q-card-section>

                <q-card-section class="q-pt-none">
                    پس از اینکه واریز شما را دریافت کردیم، سیستم ما فوراً به روز خواهد شد.
                </q-card-section>

                <q-card-actions align="right">
                    <q-btn :label="$t('transfers.history')" color="primary" v-close-popup @click="$router.push({ name: 'transfers.history', query: {ref: transfer.reference}})"/>
                </q-card-actions>
            </q-card>
        </q-dialog>
    </div>
</template>
<script>

export default {
    name: "IRBankDeposit",
    props: {
        instructions: {
            type: String,
            default: ''
        },
        fee: {
            type: Number,
            default: 0
        },
        transfer: {
            type: Object,
            default: ()=>{}
        }
    },
    computed: {
        total_amount() {
            return String(10 * (this.transfer.amount + this.fee))
        }
    },
    data() {
        return {
            openDialog: false,
            networks_map: {
                ACCOUNT: "شماره حساب",
                IBAN: "شبا",
                CARD: "شماره کارت"
            }
        }
    },
    methods: {
        copied(message) {
            this.$q.notify({
                message: message,
                position: 'top'
            })
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {},
    components: {},
}
</script>
<style>
.instructions ul{
    margin-top: 0;
    margin-bottom: 0;
}

</style>
